import React, { useState } from 'react';
import { Navbar as BootstrapNavbar, Nav, Container } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import logo from '../assets/logo-jg.png';
import { EVENTO_ROUTE } from '../routes';

const Navbar = () => {
  const location = useLocation();
  const [expanded, setExpanded] = useState(false);

  if (location.pathname === EVENTO_ROUTE) {
    return null;
  }

  return (
    <BootstrapNavbar bg="dark" variant="dark" expand="lg" className="py-3">
      <Container>
        <div className="d-flex align-items-center">
          <div className="logo-container d-none d-lg-flex">
            <img src={logo} alt="JG Wine Club Logo" className="navbar-logo" />
          </div>
          <BootstrapNavbar.Brand as={Link} to="/" className="brand-font ms-2">
            JG Wine Club
          </BootstrapNavbar.Brand>
        </div>
        <div 
          className="logo-container d-lg-none" 
          onClick={() => setExpanded(!expanded)}
          role="button"
          aria-label="Toggle navigation"
        >
          <img src={logo} alt="JG Wine Club Logo" className="navbar-logo" />
        </div>
        <BootstrapNavbar.Toggle aria-controls="basic-navbar-nav" className="d-none" />
        <BootstrapNavbar.Collapse id="basic-navbar-nav" className={expanded ? 'show' : ''}>
          <Nav className="ms-auto">
            <Nav.Link as={Link} to="/seleccion" className="nav-link">
              {location.pathname === '/seleccion' ? (
                <motion.span
                  initial={{ scale: 1 }}
                  animate={{ scale: 1.1 }}
                  transition={{ duration: 0.2 }}
                >
                  ¡Hacé tu compra!
                </motion.span>
              ) : (
                '¡Hacé tu compra!'
              )}
            </Nav.Link>
            <Nav.Link as={Link} to="/quienes-somos" className="nav-link">
              {location.pathname === '/quienes-somos' ? (
                <motion.span
                  initial={{ scale: 1 }}
                  animate={{ scale: 1.1 }}
                  transition={{ duration: 0.2 }}
                >
                  ¿Quiénes Somos?
                </motion.span>
              ) : (
                '¿Quiénes Somos?'
              )}
            </Nav.Link>
          </Nav>
        </BootstrapNavbar.Collapse>
      </Container>
    </BootstrapNavbar>
  );
};

export default Navbar; 
